<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-01 16:05:46
 * @Description: 加入我们
 -->

<template>
  <div class="join-us-wrapper">
    <div class="content">
      <div class="title">
        <span>办公场所</span>
      </div>
      <div class="img-wrapper">
        <img src="https://files.jinr.com/jinr-index/img/office-01.jpg" alt="" srcset="" />
        <img src="https://files.jinr.com/jinr-index/img/office-02.jpg" alt="" srcset="" />
        <img src="https://files.jinr.com/jinr-index/img/office-03.jpg" alt="" srcset="" />
      </div>
    </div>
    <div class="content">
      <div class="title">
        <span>团队风采</span>
      </div>
      <div class="img-wrapper">
        <img src="https://files.jinr.com/jinr-index/img/team-02.jpg" alt="" srcset="" />
        <img src="https://files.jinr.com/jinr-index/img/team-03.jpg" alt="" srcset="" />
      </div>
    </div>
    <div class="content">
      <div class="title">
        <span>招贤纳士</span>
      </div>
      <div class="text-wrapper">
        <p class="post-name">产品经理</p>
        <p>岗位职责：</p>
        <p>1、负责管理来自用户和公司内部的产品需求，指导完成需求分析，并完成产品策划、原型设计；</p>
        <p>
          2、完成项目的产品工作，包括APP、微站、PC网站、后台管理等前后端产品逻辑，实现产品创新、质量提升、转化率提升等目标；
        </p>
        <p>3、负责与各个部门沟通协作，确保产品开发进度及产品质量，保证产品按时上线发布；</p>
        <p>
          4、跟踪产品数据，进行数据分析，跟进业务部门反馈，最终确定迭代改进需求，不断完善和优化产品。
        </p>
      </div>
      <div class="text-wrapper">
        <p class="post-name">SEO</p>
        <p>岗位职责：</p>
        <p>1、负责公司网站内容更新、网站宣传资料，网站内信息的整体维护等撰写工作；</p>
        <p>
          2、按照业务要求编辑完成行业原创类文章的编写，如新闻类,评测类,推广促销类；
        </p>
        <p>3、协助优化维护部分长尾关健词推广 。</p>
      </div>
      <div class="text-wrapper">
        <p class="post-name">渠道运营</p>
        <p>岗位职责：</p>
        <p>1、负责挖掘各类用户的流量渠道，为流量指标负责；</p>
        <p>
          2、负责运营第三方广告平台，包括但不限于百度，360，广点通等平台；
        </p>
        <p>3、负责用户分层分类精准营销，结合用户行为、场景、热点等，制定营销策略；</p>
        <p>
          4、基于数据的运营优化，不断提高流量转化率，达到流量价值最大化；
        </p>
        <p>
          5、了解行业情况，关注竞品动态，形成定期报告、提出业务改善建议。
        </p>
      </div>
    </div>
    <div class="footer">
      <p class="welcome">鲸鱼大家庭，欢迎你的加入！</p>
      <p class="email">请发送您的简历至 <span>bd@jinr.com</span> 标题请注明所申请职位。</p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.join-us-wrapper {
  .content {
    padding: 0px 40px;
    .title {
      line-height: 90px;
      font-weight: 700;
      font-size: 18px;
      border-bottom: solid 1px #e5e5e5;
    }
    .img-wrapper {
      padding: 30px 0;
      text-align: center;
      img {
        width: 290px;
        margin: 5px 20px;
      }
    }
    .text-wrapper {
      border-bottom: 1px solid #e5e5e5;
      padding-bottom: 40px;
      p {
        color: #050505;
        line-height: 40px;
        font-size: 16px;
      }
      .post-name {
        line-height: 60px;
        font-size: 20px;
        font-weight: 700;
      }
    }
  }
  .footer {
    padding: 40px 0;
    text-align: center;
    .welcome {
      font-size: 30px;
      font-weight: 900;
      padding-bottom: 30px;
    }
    .email {
      font-size: 16px;
      span {
        color: #247af1;
      }
    }
  }
}
</style>
